var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed z-0"},[_c('div',{staticClass:"relative overflow-auto bg-white border border-gray-400 rounded-md h-76 newsfeed-right-section"},[_c('img',{staticClass:"img-fluid w-full",attrs:{"src":_vm.$store.state.baseUrlImg+'/client/banner.png'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }